import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
// import VueMeta from 'vue-meta'

Vue.use(VueRouter)
// Vue.use(VueMeta)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/suburb',
    name: 'suburb',
    component: () => import(/* webpackChunkName: "about" */ '../views/SuburbView.vue'),
    props: route => ({ query: route.query }),
  },
  {
    path: '/index',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/IndexView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
  },
  // {
  //   path: '/ranking',
  //   name: 'ranking',
  //   component: () => import(/* webpackChunkName: "about" */ '../views/RankingView.vue'),
  //   props: route => ({ query: route.query }),
  // }
]

const router = new VueRouter({
  mode: 'history', // remove hash #
  routes
})

export default router
